import PumaTestdriveOctNov from "../components/PumaTestdriveOctNov";

export default function PumaTestdriveOctNovPage() {
  return (
    <main className="min-h-screen text-gray-800 bg-white">
      <img src="/images/puma2024/puma.jpg" alt="" />
      <section className="max-w-3xl px-6 py-16 mx-auto">
        <h1 className="mb-8 text-3xl font-bold text-center">
          Заяви тестдрайв на новия Ford Puma
        </h1>
        <p className="mb-12 text-center text-gray-600">
          Попълнете формата по-долу, за да заявите тестдрайв в предпочитано
          представителство. Всички полета са задължителни.
        </p>
        <PumaTestdriveOctNov />
      </section>
    </main>
  );
}
